import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { BiErrorCircle } from "react-icons/bi";
import Modal from "../Modal";
import Headline from "../Headline";

import {
  ErrorHeader,
  ErrorIcon,
  TitleModal,
  CustomModal,
} from "./ModalError.Style";

const ModalError = (props) => {
  const { error, body, headerModal, headerTitle, children, modalIcon } = props;

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowError(error);
  }, [error]);

  return (
    <CustomModal
      as={Modal}
      {...props}
      show={showError}
      headerModal={
        <ErrorHeader>
          <ErrorIcon as={modalIcon} />
          {headerModal || (
            <TitleModal as={Headline} nivel="5" text={headerTitle} />
          )}
        </ErrorHeader>
      }
      opacityGlass={1}
    >
      {body || children}
    </CustomModal>
  );
};

ModalError.defaultProps = {
  error: null,
  body: null,
  headerModal: null,
  headerTitle: "Ops, algo deu errado :(",
  modalIcon: BiErrorCircle,
};

ModalError.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  body: PropTypes.element,
  headerModal: PropTypes.element,
  headerTitle: PropTypes.string,
  modalIcon: PropTypes.elementType,
};

export default ModalError;
